export const storeUTMParams = () => {
  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of params.entries()) {
    if (key.startsWith("utm_")) {
      localStorage.setItem(key, value);
    }
  }
};
